<form [formGroup]="addressForm" (ngSubmit)="onSubmit()" appTrapFocusDirective>
  <div formArrayName="addresses">
    <div class="row no-gutters bot_spa_aft_sect_heading">
      <div class="col-12">
        <span>
          {{'address-validation-popup.confirmAddressData'|translate}}
        </span>
      </div>
    </div>
    <div *ngFor="let group of addressesArray?.controls; let i = index" [formGroupName]="i" role="radiogroup">
      <ng-container *ngIf="checkObject(addressData[i])">
        <div class="row no-gutters bot_spa_aft_sect_heading">
          <div class="col-12">
            <ng-container *ngIf="addressData[i].main_application==0">
              <span class="sectionHeading_two" [attr.id]="'applicant' + i">
                <ng-container *ngIf="sameAddressData">{{'address-validation-popup.applicants'|translate}}
                </ng-container>
                <ng-container *ngIf="!sameAddressData">{{'address-validation-popup.applicant'|translate}}
                </ng-container>
              </span>
            </ng-container>
            <ng-container *ngIf="addressData[i].main_application==1">
              <span class="sectionHeading_two" [attr.id]="'coapplicant' + i">
                {{'address-validation-popup.coapplicant'|translate}}
              </span>
            </ng-container>
          </div>
        </div>
        <!-- {{ group.value.main_application }} -->
        <div class="row no-gutters space_between_section">
          <div class=" col-md col-12">
            <!-- Original Address -->
            <span class="field_heading_minHeight_label d-flex align-items-center"
              [id]="'original'+i">{{'address-validation-popup.original'|translate}}</span>
            <label class="d-flex radio_button_border nonSelectBorder align-items-center  field_lable_bot_margin_unset">
              <div [ngClass]="group.value.selectedAddress==addressData[i].original_address?'cst-rd-check':'cst-rd'">
                <input type="radio" [value]="addressData[i].original_address" [attr.name]="'selectedAddress_' + i"
                  formControlName="selectedAddress"
                  [attr.aria-labelledby]="(addressData[i].main_application==1 ? 'coapplicant' + i : 'applicant' + i) + ' ' + 'original'+i+' '+'orgAdre'+i"
                  tabindex="0" />
                <div class="border-on-focus"></div>
              </div>
              <span class="ml-3" [id]="'orgAdre'+i" [innerHTML]="formattedOriginalAddress[i]"></span>
            </label>
          </div>
          <div class="col-md col-12 space_between_field">
            <!-- Suggested Address -->
            <span class="field_heading_minHeight_label d-flex align-items-center"
              [id]="'suggessted'+i">{{'address-validation-popup.suggested'|translate}}</span>
            <label class="d-flex radio_button_border nonSelectBorder align-items-center  field_lable_bot_margin_unset">
              <div [ngClass]="group.value.selectedAddress==addressData[i].suggested_address?'cst-rd-check':'cst-rd'">
                <input type="radio" [value]="addressData[i].suggested_address" [attr.name]="'selectedAddress_' + i"
                  formControlName="selectedAddress"
                  [attr.aria-labelledby]="(addressData[i].main_application==1 ? 'coapplicant' + i : 'applicant' + i) + ' ' + 'suggessted'+i+' '+'sugAdre'+i" />
                <div class="border-on-focus"></div>
              </div>
              <span class="ml-3" [id]="'sugAdre'+i" [innerHTML]="formattedSuggestedAddress[i]"></span>
            </label>
          </div>
        </div>

      </ng-container>
    </div>
  </div>
  <div class="button-container">
    <button class="saveNextBtn_features saveBtn" type="submit" [disabled]="addressForm.get('addresses')?.invalid"
      tabindex="0">{{'address-validation-popup.save'|translate}}</button>
  </div>
</form>